export default "__VITE_ASSET__BWRpzE$9__"